module.exports = __webpack_public_path__ + "img/icon-500-color.844d8ac8.svg";